import round2Decimals from "./round2Decimals";

/*
  Calcula los valores de ajusteSubtotal / ajuste<descripcionFactura> necesarios para que
  el Total a pagar capturado coincida con el Total del XML (CFDI) leído. Se basa siempre en
  los montos "VI" (sin ajustes manuales previos), así que sobreescribe cualquier ajuste ya
  capturado con el cálculo fresco a partir del XML.

  arrayImpuestos: [{ descripcionFactura, totalImpuestosVI }]
  arrayRetenciones: [{ descripcionFactura, totalRetencionesVI }]
  xmltotales: { SubTotal, Total }
*/
export default function calcularAjusteAutomaticoFactura({
  subtotalVI,
  cuentasProveedorVI,
  arrayImpuestos = [],
  arrayRetenciones = [],
  xmltotales,
  ajusteMax,
}) {
  const clampAjuste = (diferencia, baseVI) => {
    const minimo = Math.max(-ajusteMax, -baseVI);
    return round2Decimals(Math.min(Math.max(diferencia, minimo), ajusteMax));
  };

  const totalImpuestosVI = arrayImpuestos.reduce((acc, v) => acc + v.totalImpuestosVI, 0);
  const totalOriginalAPagar = round2Decimals(subtotalVI + totalImpuestosVI - cuentasProveedorVI);
  const diferenciaOriginal = round2Decimals((xmltotales?.Total || 0) - totalOriginalAPagar);

  const ajustes = {};

  const ajusteSubtotal = clampAjuste(round2Decimals((xmltotales?.SubTotal || 0) - subtotalVI), subtotalVI);
  ajustes.ajusteSubtotal = ajusteSubtotal;

  const totalConAjusteSubtotal = round2Decimals(subtotalVI + ajusteSubtotal + totalImpuestosVI - cuentasProveedorVI);
  let diferenciaRestante = round2Decimals((xmltotales?.Total || 0) - totalConAjusteSubtotal);

  if (diferenciaRestante !== 0) {
    if (arrayImpuestos.length > 0) {
      const impuestoMayor = arrayImpuestos.reduce(
        (max, item) => (item.totalImpuestosVI > max.totalImpuestosVI ? item : max),
        arrayImpuestos[0]
      );
      const ajusteImpuesto = clampAjuste(diferenciaRestante, impuestoMayor.totalImpuestosVI);
      ajustes["ajuste" + impuestoMayor.descripcionFactura] = ajusteImpuesto;
      diferenciaRestante = round2Decimals(diferenciaRestante - ajusteImpuesto);
    } else if (arrayRetenciones.length > 0) {
      const retencionMayor = arrayRetenciones.reduce(
        (max, item) => (item.totalRetencionesVI > max.totalRetencionesVI ? item : max),
        arrayRetenciones[0]
      );
      const ajusteRetencion = clampAjuste(-diferenciaRestante, retencionMayor.totalRetencionesVI);
      ajustes["ajuste" + retencionMayor.descripcionFactura] = ajusteRetencion;
      diferenciaRestante = round2Decimals(diferenciaRestante + ajusteRetencion);
    }
  }

  return {
    diferenciaOriginal,
    ajustes,
    restante: diferenciaRestante,
  };
}
